import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './lib/auth';
import { isSupabaseConfigured } from './lib/supabase';
import ConfigMissing from './pages/ConfigMissing';
import Layout from './components/Layout';
import Spinner from './components/Spinner';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import NotAuthorized from './pages/NotAuthorized';
import Dashboard from './pages/Dashboard';
import Patients from './pages/Patients';
import PatientDetail from './pages/PatientDetail';
import Agenda from './pages/Agenda';
import Alerts from './pages/Alerts';
import Settings from './pages/Settings';

export default function App() {
  const location = useLocation();
  const auth = useAuth();

  if (!isSupabaseConfigured) {
    return <ConfigMissing />;
  }

  // Processar tokens do magic link antes de qualquer redirect para /login
  if (location.pathname === '/auth/callback') {
    return <AuthCallback />;
  }

  if (auth.status === 'loading') {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center">
        <Spinner label="Verificando sessão…" />
      </div>
    );
  }

  if (auth.status === 'signed_out') {
    return (
      <Routes>
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  if (auth.practiceLoading) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center">
        <Spinner label="Carregando consultório…" />
      </div>
    );
  }

  if (auth.context === null) {
    return (
      <NotAuthorized
        email={auth.session.user.email ?? ''}
        loading={false}
      />
    );
  }

  return (
    <Layout session={auth.session} context={auth.context}>
      <Routes>
        <Route path="/" element={<Dashboard context={auth.context} />} />
        <Route path="/patients" element={<Patients />} />
        <Route path="/patients/:id" element={<PatientDetail />} />
        <Route path="/agenda" element={<Agenda />} />
        <Route path="/alerts" element={<Alerts />} />
        <Route path="/settings" element={<Settings context={auth.context} />} />
        <Route path="/auth/callback" element={<Navigate to="/" replace />} />
        <Route path="/login" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}
